import styled from 'styled-components'

import { Image } from '@application/Interfaces/Atoms/Image'
import { DoubleQuoteIcon } from '@application/Interfaces/Icons/DoubleQuoteIcon/DoubleQuoteIcon'

export const ItemWrapper = styled.div`
    padding: 40px;
    border-radius: 10px;
    position: relative;
    background-color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.boxShadow.level2};
    margin-bottom: 15px;

    @media ${(props) => props.theme.query.min.tablet} {
        margin-bottom: 0;
    }
`

export const Text = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g500};
    line-height: 220%;
    padding-bottom: 30px;
    margin-bottom: 30px;
    border-bottom: 1px solid ${(props) => props.theme.color.g300};
    position: relative;
    z-index: 1;

    @media ${(props) => props.theme.query.min.tablet} {
        min-height: 185px;
    }
`

export const AvatarImage = styled(Image)`
    height: 60px;
    width: 60px;
    border-radius: 50%;
`

export const CustomerName = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.bold};
    color: ${(props) => props.theme.color.a500};
    margin-bottom: 3px;
`
export const CompanyName = styled.p`
    ${(props) => props.theme.typo.bodyS};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g500};
    font-style: italic;
`

export const Icon = styled(DoubleQuoteIcon)`
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 0;
`
